import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';
import { AddToWishlistDto } from '../../../dto/wishlist/addtowishlist/addtowishlistdto';

export interface AddToWishlistRequest extends APIRequest
{
    getAddToWishlistRequest(): AddToWishlistDto;
}

export class AddToWishlistRequestImpl extends APIRequestDtoImpl implements AddToWishlistRequest
{
    constructor(private addToWishlistData: AddToWishlistDto)
    {
        super();
    }

    getAddToWishlistRequest(): AddToWishlistDto
    {
        return this.addToWishlistData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/wishlist/addtowishlist/addtowishlistrequest.tsx